import { GraphQLClient } from 'graphql-request';
import { RequestConfig } from 'graphql-request/src/types';

export const getGraphqlRequestClient = (url: string, config: RequestConfig = {}) => new GraphQLClient(url, config);
